<template>
  <svg
    width="36"
    height="61"
    viewBox="0 0 36 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.1579 59.7769L27.8421 59.7769C31.7953 59.7769 35 56.2894 35 51.9874L35 9.14527C35 4.84314 31.7953 1.35579 27.8421 1.35579L8.1579 1.35579C4.2046 1.35579 1.00001 4.84314 1.00001 9.14527L1 51.9874C1 56.2894 4.20459 59.7769 8.1579 59.7769Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.011 50.9151C18.3696 50.9151 18.6602 51.2058 18.6602 51.5643C18.6602 51.9228 18.3696 52.2134 18.011 52.2134"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M17.9883 50.9151C17.6297 50.9151 17.3392 51.2058 17.3392 51.5643C17.3392 51.9228 17.6297 52.2134 17.9883 52.2134"
      stroke="white"
      stroke-width="2"
    />
  </svg>
</template>

<script>
export default {
  name: "AppPhoneIcon",
};
</script>
